<template>
  <section>

    <div style="margin: 10px;margin-left: 100px;">
      <el-form :inline="true" :model="filters" >
        <el-form-item  label-width="100px">
          <el-input placeholder="请输入内容" v-model="filters.name" style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="validateShielding()">添加黑词</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--新增界面-->
    <el-form :model="addForm" label-width="80px" ref="addForm" > <!--:rules="addFormRules" -->
      <el-form-item label="黑词设置" label-width="100px">
        <el-input
          style="margin-top:10px; margin-right: 10px;"
          type="textarea"
          disabled="true"
          :rows="10"
          v-model="addForm.shielddingWords" value="dddd">
        </el-input>
      </el-form-item>
    </el-form>
    <!--<div slot="footer" class="dialog-footer" style="text-align: center;margin-bottom: 10px;">
      <el-button type="primary" v-show="editBut" @click.native="handleEdit()"  >编辑</el-button>
      <el-button type="primary" v-show="submitBut" @click.native="addSubmit()"  >提交</el-button>
    </div>-->
  </section>
</template>

<script>
  import { getShieldingInfo,updateShieldingInfo,validateShieldingWords} from '../../api/api';
  export default {
    data() {

      return {
        markCount:0,
        textarea:'',

        filters:{
            name:''
        },

        //新增界面数据
        addForm: {
          id:'',
          shielddingWords:'',
        }
      }
    },
    methods: {

      //获取编译资讯列表
      getInitData() {
        getShieldingInfo().then((res) => {
          this.addForm.id = res.data.data.shielding.id;
          this.addForm.shielddingWords = res.data.data.shielding.shieldingWords;
        });
      },

      //显示编辑界面
      handleEdit() {
        if(this.markCount ==1){
          this.shieldingDisable = false;
        }else{
          this.$notify({
            title: '提示',
            message: '请先验证黑词是否存在',
            type: 'error'
          });
        }
      },

      //显示编辑界面
      validateShielding() {
          var _this = this;
          if(this.filters.name !=''){

            if(_this.filters.name.length<2){
              _this.$notify({
                title: '提示',
                message: '该词最少为两个字符',
                type: 'info'
              });
              return;
            }

            var param = {name:_this.filters.name}
            validateShieldingWords(param).then((res) => {
              if(res.data.status !=200){
                _this.$notify({
                  title: '提示',
                  message: '该词已存在',
                  type: 'info'
                });
              }else{
                const formData = new FormData();
                formData.append('id', _this.addForm.id);
                formData.append('shieldingWords', _this.addForm.shielddingWords+'|'+_this.filters.name);
                updateShieldingInfo(formData).then((res) => {
                  if(res.data.status == 200){
                    _this.$notify({
                      title: '成功',
                      message: '添加成功',
                      type: 'success'
                    });
                    _this.addForm.shielddingWords= _this.addForm.shielddingWords+'|'+_this.filters.name;
                  }else{
                    _this.$notify({
                      title: '失败',
                      message: '添加失败',
                      type: 'fail'
                    });
                  }
                });
              }
            });
            this.markCount = 1;
          }else{
            this.$notify({
              title: '提示',
              message: '请输入要验证的内容',
              type: 'info'
            });
          }
      },

      //新增
      addSubmit: function () {
        const formData = new FormData();
        formData.append('id', this.addForm.id);
        formData.append('shieldingWords', this.addForm.shielddingWords);
      },
    },
    mounted() {
        this.getInitData();
    }
  }
</script>

<style scoped>
</style>
